<div class="row">
    <div class="col-xs-7 col-sm-5 col-md-5 col-xl-5">
        <q-header-logo [appName]="app"> </q-header-logo>
        <div
            *ngIf="showEnvironment"
            class="badge badge-light app-environment"
            >{{ environment | uppercase }}</div
        >
    </div>
    <div class="hidden-xs col-sm-4 col-md-4 col-lg-4">
        <div class="header-search-wrapper">
            <q-search-dropdown-filter
                [searchSelection]="eventSearchCriteria.keyword"
                [searchDropdownList]="searchDropdownList"
                (searchDropdownSelection)="handleSearchStringRequest($event)"
            ></q-search-dropdown-filter>
        </div>
    </div>
    <div class="col-xs-5 col-sm-3 col-md-3 col-lg-3">
        <div class="float-right">
            <ul class="list-inline">
                <li class="list-inline-item">
                    <q-dropdown-popup
                        [list]="apps | async"
                        [align]="'right'"
                        [itemTemplate]="appItems"
                    >
                        <span
                            class="qb-sprite qb-sprite-apps"
                            title="Application Selector"
                        ></span>
                        <ng-template #appItems let-app>
                            <a
                                class="q-popup-item q-popup-item-link app-link"
                                href="{{ app.url }}"
                            >
                                <img
                                    *ngIf="app.iconSmall"
                                    src="{{ app.iconSmall }}"
                                    width="18"
                                />
                                <span>{{ app.name }}</span>
                            </a>
                        </ng-template>
                    </q-dropdown-popup>
                </li>
                <li class="list-inline-item">
                    <q-dropdown-popup
                        [list]="userMenu"
                        [align]="'right'"
                        (itemClick)="onItemClick($event)"
                    >
                        <span
                            class="qb-sprite qb-sprite-user"
                            title="{{ userName }}"
                        ></span>
                    </q-dropdown-popup>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="alert-layout">
    <q-alert-detail></q-alert-detail>
</div>
